import { Table as TableAntd } from 'antd';
import styled, { css } from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Table = styled(TableAntd)`
  .ant-table {
    font-size: 12px;
    line-height: 15px;
    background-color: transparent;
    font-weight: 550;
    th,
    td {
      padding: 23px;
    }
  }
  tr {
    height: 60px;
  }

  .ant-table-thead > tr > th {
    background-color: ${COLOR.WHITE_SMOKE};
    font-weight: bold;

    &:before {
      height: 45px !important;
    }
  }
  .ant-table-tbody > tr.pending {
    color: ${COLOR.GUNSMOKE};
    font-weight: normal;
    cursor: default;
  }

  .ant-table-tbody > tr.unread {
    font-weight: bold;
    td:first-child:before {
      content: '';
      height: 6px;
      width: 6px;
      background-color: ${COLOR.CHEMISTRY};
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
      position: absolute;
      top: calc(50% - 3px);
      left: 10px;
    }
  }
  ${({ rowSelection }) =>
    rowSelection
      ? ''
      : css`
          && tbody > tr:not(.pending):hover > td {
            background: ${COLOR.WHITE};
            cursor: pointer;
          }
        `}
` as typeof TableAntd;
